@include media-breakpoint-up(xl) {
    .app-nav {
        display: flex;
        align-items: center;
        padding-right: 0 !important;

        .node {
            padding-bottom: 18px;
            padding-right: 24px;
            padding-left: 24px;
            position: relative;

            &:first-of-type {
                padding-left: 0;
            }

            &:last-of-type {
                padding-right: 0;
                
                .parent::after {
                    content: none;
                }
            }

            .parent {
                padding: 0;

                &::after {
                    content: '';
                    position: absolute;
                    width: 1px;
                    height: calc(100% - 18px);
                    background-color: #00000026;
                    right: 0;
                    top: 0;
                }

                a {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    color: $primary;
                    @include text-size(16);
                    @include line-height(21);
                    font-family: $font-family-primary;
                    text-decoration: none;

                    svg {
                        @include svg-format(16px, 12px, $primary);
                        margin-left: 8px;
                        transition: all 500ms;
                    }
                }

                .mobile-dropdown-toggle {
                    display: none;
                }

            }

            .simple-children {
                padding: 40px;
                display: none;
                position: absolute;
                background: #FFFFFF;
                z-index: 15;
                background: #F4F4F4;
                box-shadow: 0px 3px 3px #0000000D;
                left: -40px;
                top: 100%;
                justify-content: space-between;

                .simple-children__links {
                    display: flex;
                    flex-direction: column;

                    span {
                        font-family: $font-family-primary;
                        color: #00000080;
                        @include text-size(12);
                        @include line-height(16);
                        margin-left: 16px;
                        margin-bottom: 9px;
                        text-transform: uppercase;
                    }


                    a.title {
                        font-family: $font-family-primary;
                        @include text-size(16);
                        @include line-height(21);
                        text-decoration: none;
                        margin-bottom: 0;
                        color: $primary;
                        white-space: nowrap;
                        border-radius: 5px;
                        padding: 8px 16px;

                        &:hover,
                        &:focus {
                            text-decoration: underline;
                            background-color: #E9E9E9;

                        }
                    }
                }
                &:not(:first-child) {

                    &:has(.app-nav__cta) {
                        left: auto;
                        right: -40px;
                    }
                }

            }

            .children-mobile {
                display: none;
            }

            &:hover,
            &:focus-within {
                .parent {
                    a {
                        text-decoration: underline;

                        svg {
                            transform: rotate(180deg);
                        }
                    }
                }


                .simple-children {
                    animation: subNavIn 0.2s ease-in-out forwards;
                    display: flex;
                }

            }
        }

        &__cta {
            margin-left: 40px;
            width: 287px;
            height: 426px;
            background-size: cover;
            background-position: center;
            border-radius: 5px;
        }

        &__cta-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 24px;
            color: #FFFFFF;
            background: rgba(16, 36, 63, 0.85);
            border-radius: 5px;

            .cta-title {
                text-align: center;
                @include text-size(16);
                @include line-height(24);
                font-weight: 500;
                margin-bottom: 8px;
                text-transform: uppercase;
            }

            .cta-description {
                text-align: center;
                @include text-size(16);
                @include line-height(24);
                font-weight: 400;
                margin-bottom: 24px;
            }

            a {
                @include text-size(16);
                @include line-height(24);
                font-weight: 500;
                color: #FFFFFF;
                text-decoration: none;
                text-transform: uppercase;

                svg {
                    @include svg-format(7px, 11px, #FFFFFF);
                    margin-left: 7px;
                    margin-bottom: 3px;
                    transition: all 500ms;
                }

                &:hover,
                &:focus-within {
                    color: #FFFFFF;
                    text-decoration: underline;

                    svg {
                        transform: translateX(4px);
                    }

                }
            }
        }
    }
}

@include media-breakpoint-down(xl) {
    .app-nav {
        display: none;

        &.show {
            display: flex;
            flex-direction: column;
            padding-top: 32px;
            justify-content: flex-start;
            align-items: center;
            height: calc(100% - 90px);
            position: fixed;
            width: 100%;
            overflow-y: scroll;
            top: 0;
            left: 0;
            z-index: 999;
            background-color: #F4F4F4;
            max-width: none;

            .node {
                padding-right: 0;
                position: relative;
                width: 100%;

                .parent {
                    padding: 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #00000026;
                    padding-top: 24px;
                    padding-bottom: 24px;

                    a {
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        color: $primary;
                        @include text-size(16);
                        @include line-height(21);
                        font-family: $font-family-primary;
                        text-decoration: none;

                        svg {
                            display: none;
                        }
                    }

                    .mobile-dropdown-toggle {
                        display: block;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 40px;
                        height: 40px;
                        background-color: #FFFFFF;
                        border-radius: 5px;
                        box-shadow: 0px 0px 6px #00000029;

                        svg {
                            @include svg-format(16px, 12px, $primary);
                            transition: all 500ms;
                        }
                    }

                }

                &.last {
                    .parent {
                        border-bottom: none;

                    }

                    .simple-children {
                        border-top: 1px solid #00000026;
                    }
                }

                .simple-children {
                    display: none;
                }

                &.open {
                    .parent {
                        .mobile-dropdown-toggle {
                            svg {
                                transform: rotate(180deg);
                            }
                        }
                    }

                    .simple-children {
                        display: block;
                        position: static;
                        background: #FFFFFF;
                        background: #F4F4F4;
                        box-shadow: none;
                        justify-content: space-between;
                        border-bottom: 1px solid #00000026;
                        padding-bottom: 24px;

                        .simple-children__links {
                            display: flex;
                            flex-direction: column;

                            span {
                                display: none;
                            }


                            a.title {
                                font-family: $font-family-primary;
                                @include text-size(16);
                                @include line-height(21);
                                text-decoration: none;
                                margin-bottom: 0;
                                color: $primary;
                                white-space: nowrap;
                                border-radius: 5px;
                                padding: 24px 0 0;
                            }
                        }

                    }
                }

            }

            .app-nav__cta {
                margin-top: 24px;
                margin-left: 0;
                width: 100%;
                height: 426px;
                background-size: cover;
                background-position: center;
                border-radius: 5px;
            }

            .app-nav__cta-content {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 24px;
                color: #FFFFFF;
                background: rgba(16, 36, 63, 0.85);
                border-radius: 5px;

                .cta-title {
                    text-align: center;
                    @include text-size(16);
                    @include line-height(24);
                    font-weight: 500;
                    margin-bottom: 8px;
                    text-transform: uppercase;
                }

                .cta-description {
                    text-align: center;
                    @include text-size(16);
                    @include line-height(24);
                    font-weight: 400;
                    margin-bottom: 24px;
                }

                a {
                    @include text-size(16);
                    @include line-height(24);
                    font-weight: 500;
                    color: #FFFFFF;
                    text-decoration: none;
                    text-transform: uppercase;

                    svg {
                        @include svg-format(7px, 11px, #FFFFFF);
                        margin-left: 7px;
                        margin-bottom: 3px;
                        transition: all 500ms;
                    }

                    &:hover,
                    &:focus-within {
                        color: #FFFFFF;
                        text-decoration: underline;

                        svg {
                            transform: translateX(4px);
                        }

                    }
                }
            }
        }
    }
}

@keyframes subNavIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}